export enum PaymentMethodType {
  CREDIT_CARD = 'CREDIT_CARD',
  PHYSICAL_POS_SQUARE = 'PHYSICAL_POS_SQUARE',
  ALIPAY = 'ALIPAY',
  WECHATPAY = 'WECHATPAY',
  STRIPE_KLARNA = 'STRIPE_KLARNA',
  CASH = 'CASH',
  SEASON_PASS = 'SEASON_PASS',
  THIRD_PARTY = 'THIRD_PARTY',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export enum CardType {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMEX = 'AMEX',
  UNKNOWN = 'UNKNOWN',
}
